import { SvgIcon } from '@material-ui/core';
import { Color, ColorDynamic } from "../theme/Color.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function overrideRadio(theme) {
  theme.props.MuiRadio = {
    color: 'primary',
    icon: /*#__PURE__*/_jsx(SvgIcon, {
      children: /*#__PURE__*/_jsx("circle", {
        cx: "12",
        cy: "12",
        r: "9",
        fill: ColorDynamic.White,
        stroke: "currentColor"
      })
    }),
    checkedIcon: /*#__PURE__*/_jsxs(SvgIcon, {
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "12",
        cy: "12",
        r: "9",
        fill: "currentColor",
        stroke: "currentColor"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "12",
        cy: "12",
        r: "4",
        fill: Color.White
      })]
    })
  };
  theme.overrides.MuiRadio = {
    root: {
      color: ColorDynamic.Dark100,
      width: theme.spacing(3),
      height: theme.spacing(3),
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      padding: 0
    },
    colorPrimary: {
      '&$checked$disabled': {
        color: ColorDynamic.Silver500
      },
      '&:hover:not($checked)': {
        color: ColorDynamic.Dark100
      }
    }
  };
}